import { Stack, StackProps, styled } from '@mui/material';
import { useFeatureFlags } from '../../services/featureFlags/hooks/useFeatureFlags';
import { DevOnlyFeature } from '../commonUI/viewMode/DevOnlyFeature';
import { DiagnosticFeature } from '../commonUI/viewMode/DiagnosticFeature';
import DebugInfoLauncher from '../debugInfo/DebugInfoLauncher';
import { DuckDBLauncher } from '../duckDB/DuckDbLauncher';
import { APIExplorerNavButton } from './components/buttons/APIExplorerNavButton';
import { CollectionsNavButton } from './components/buttons/CollectionsNavButton';
import { DevSandboxNavButton } from './components/buttons/DevSandboxNavButton';
import FeedbackLauncher from './components/buttons/FeedbackLauncher';
import { OnboardingNavButton } from './components/buttons/OnboardingNavButton';
import { RanchSummaryButton } from './components/buttons/RanchSummaryNavButton';
import { ReportsNavButton } from './components/buttons/ReportsNavButton';
import { ScansNavButton } from './components/buttons/ScansNavButton';
import { SettingsNavButton } from './components/buttons/SettingsNavButton';
import UserNavButton from './components/buttons/UserNavButton';
import { NavbarBase } from './components/NavbarBase';

const ButtonStack = styled(Stack)<StackProps>(() => ({
  width: '100%',
  gap: '8px',
  justifyContent: 'space-between',
  padding: '8px 0',
}));

export const Navbar = () => {
  const { Reports, Onboarding } = useFeatureFlags();

  return (
    <NavbarBase>
      <Stack
        height='100%'
        width='100%'
        flexDirection='column'
        alignContent='flex-start'
        overflow='hidden'
      >
        <ButtonStack sx={{ marginBottom: 'auto' }}>
          <RanchSummaryButton />
          <ScansNavButton />
          {Reports && <ReportsNavButton />}
          <DiagnosticFeature>
            <CollectionsNavButton />
          </DiagnosticFeature>
          <SettingsNavButton />
        </ButtonStack>
        <ButtonStack sx={{ overflowY: 'auto', overflowX: 'hidden' }}>
          {Onboarding && <OnboardingNavButton />}
          <DiagnosticFeature>
            <DebugInfoLauncher />
            <APIExplorerNavButton />
          </DiagnosticFeature>
          <DevOnlyFeature>
            <DuckDBLauncher />
            <DevSandboxNavButton />
          </DevOnlyFeature>
          <FeedbackLauncher />
        </ButtonStack>
        <ButtonStack>
          <UserNavButton />
        </ButtonStack>
      </Stack>
    </NavbarBase>
  );
};
